import React from 'react';
import { usePositionProfit } from '../../../hooks/usePositionProfit';

const Profilt = ({ positon }) => {
  const {
    profit: backgroundProfit
    // calculatedBy,
    // timestamp,
    // isCalculating,
    // isAvailable,
    // positionId
  } = usePositionProfit(positon);

  return (
    <div className="text-end text-sm font-bold" style={{ color: +backgroundProfit < 0 ? '#EF4533' : '#28AFFF' }}>
      {backgroundProfit.toFixed(2)}
    </div>
  );
};

export default Profilt;
